import React from "react";
import { formatFileSize } from "../../utils/utils";
import { truncateFileName } from "../../../../utils/truncate";
import { Tooltip } from "react-tooltip";

const SelectedFiles = ({selectedFiles,setSelectedFiles, getFileIcon}) => {

    const handleRemoveFile = (id) => {
        setSelectedFiles(prev => (prev.filter(file => file?.id !== id)))
    }
  return (
    <>
      {selectedFiles.length > 0 &&
        selectedFiles.map((file, index) => {
          const fileURL = file?.s3_url;
          return (
            <React.Fragment key={index}>
              <div
                data-tooltip-id={file?.file_name}
                className="pdf_box_sec_inner_single"
                style={{ position: "relative" }}
              >
                <a href={fileURL} target="_blank" rel="noopener noreferrer">
                  <span>
                    <h5>
                      <img src={getFileIcon(file?.file_type, true)} />
                      {truncateFileName(file?.file_name) +
                        " (" +
                        formatFileSize(file?.file_size) +
                        ")"}
                    </h5>
                  </span>
                </a>
                <i
                  className="fas fa-times"
                  onClick={() => handleRemoveFile(file?.id)}
                ></i>

              </div>
              <Tooltip
                id={file.file_name}
                place="top"
                content={`${file.file_name} (${formatFileSize(file?.file_size)})`}
                type="light"
                effect="float"
              />
            </React.Fragment>
          );
        })}
    </>
  );
};

export default SelectedFiles;
